import { createFileRoute, useParams } from "@tanstack/react-router"
import { StudentContactPersons } from "@/pages/cursisten/$studentId/tweede-aanspreekpunt"

export const Route = createFileRoute(
  "/beheer/cursisten/$studentId/tweede-aanspreekpunt/",
)({
  component: StudentContactPersonsRoute,
})

function StudentContactPersonsRoute() {
  const { studentId } = useParams({ from: "/beheer/cursisten/$studentId" })

  return <StudentContactPersons studentId={Number(studentId)} />
}
